import { useEffect, useRef } from "react";

const VoiceWave = ({ className = "" }) => {
  const ref = useRef(null);
  const mouse = useRef(0.5);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let t = 0;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = canvas.offsetWidth * dpr;
      canvas.height = canvas.offsetHeight * dpr;
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      const r = canvas.getBoundingClientRect();
      mouse.current = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    };
    canvas.addEventListener("pointermove", onMove);

    const draw = () => {
      t += 0.035;
      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      const bars = 72;
      const gap = w / bars;
      const bw = Math.max(2, gap * 0.42);

      for (let i = 0; i < bars; i++) {
        const x = i / bars;
        const dist = Math.abs(x - mouse.current);
        const boost = Math.max(0, 1 - dist * 2.4);
        const amp =
          (Math.sin(t * 2 + i * 0.55) * 0.5 + 0.5) *
          (0.22 + 0.78 * Math.abs(Math.sin(t * 0.65 + i * 0.13)));
        const bh = (amp * 0.62 + boost * 0.38) * h * 0.82 + h * 0.05;

        const grad = ctx.createLinearGradient(0, h / 2 - bh / 2, 0, h / 2 + bh / 2);
        grad.addColorStop(0, "#34D399");
        grad.addColorStop(0.55, "#22D3EE");
        grad.addColorStop(1, "#0EA5E9");
        ctx.fillStyle = grad;
        ctx.globalAlpha = 0.3 + amp * 0.7;

        const px = i * gap + (gap - bw) / 2;
        const py = h / 2 - bh / 2;
        const r = bw / 2;
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(px, py, bw, bh, r);
        else ctx.rect(px, py, bw, bh);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      canvas.removeEventListener("pointermove", onMove);
    };
  }, []);

  return <canvas ref={ref} data-testid="voice-wave-canvas" className={className} />;
};

export default VoiceWave;
